<template>
  <div
    class="VB_Brochure_Wrapper"
    :style="{ width: `${width}px` || 'auto', height: `${height}px` || 'auto' }"
  >
    <div
      :class="['VB_Brochure_Page', `VB_Brochure_Page--${page}`]"
      :style="{ transform: `scale(${zoom})` }"
    >
      <div class="VB_Brochure_Pager"></div>
      <viewmedica-demo-overlay>
        <ViewmedicaBrochureHeader :logo="logo" />
        <ViewmedicaBrochureArt :image="image" />
        <ViewmedicaBrochureText :textData="stepData" />
        <ViewmedicaBrochureFooter />
      </viewmedica-demo-overlay>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import ViewmedicaBrochureArt from "./ViewmedicaBrochureArt.vue";
import ViewmedicaBrochureText from "./ViewmedicaBrochureText.vue";
import ViewmedicaBrochureHeader from "./ViewmedicaBrochureHeader.vue";
import ViewmedicaBrochureFooter from "./ViewmedicaBrochureFooter.vue";
import ViewmedicaDemoOverlay from "./ViewmedicaDemoOverlay.vue";

export default {
  name: "ViewmedicaBrochurePage",

  components: {
    ViewmedicaBrochureArt,
    ViewmedicaBrochureText,
    ViewmedicaBrochureHeader,
    ViewmedicaBrochureFooter,
    ViewmedicaDemoOverlay
  },

  props: {
    image: {
      required: true
    },

    logo: {
      required: true
    },

    page: {
      required: true,
      type: Number
    }
  },

  computed: {
    ...mapState({
      zoom: s => s.zoom.current,
      width: s => s.dimensions.width,
      height: s => s.dimensions.height
    }),

    ...mapGetters({
      pageStepData: "pageStepData"
    }),

    stepData() {
      return this.pageStepData(this.page);
    }
  }
};
</script>

<style lang="scss">
.VB_Brochure_Wrapper {
  position: relative;
  margin: 20px auto;
  background: white;
  page-break-after: always;
  box-shadow: 0px 5px 10px #2a2a2a;

  @media screen {
    &:first-child {
      margin-top: 70px;
    }

    &:last-child {
      margin-bottom: 30px;
    }
  }

  @media print {
    margin: 0 !important;
    padding: 0 !important;
    width: 612pt !important;
    height: 767pt !important;
    box-shadow: none;
    box-decoration-break: clone;
  }

  &:last-child {
    page-break-after: avoid;
  }
}

.VB_Brochure_Page {
  width: 612pt; //8.5in
  height: 778pt; //11 in
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: top left;

  @media print {
    padding: 0 !important;
    margin: 0 !important;
    box-shadow: none;
    background: transparent;
    box-decoration-break: clone;
    transform: none !important;
    height: 767pt !important;
    overflow: hidden;
  }
}

.VB_Brochure_Pager {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  margin: auto;
}
</style>
